import { render, staticRenderFns } from "./New_substep.vue?vue&type=template&id=95968e8a&scoped=true&"
import script from "./New_substep.vue?vue&type=script&lang=js&"
export * from "./New_substep.vue?vue&type=script&lang=js&"
import style0 from "./New_substep.vue?vue&type=style&index=0&id=95968e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95968e8a",
  null
  
)

export default component.exports